/*global _, addiesaas */
const prefix = 'profile.autoload.data'
const F = {
  USER: `${prefix}.user`,
  ORDERS: `${prefix}.orders`,
  FAMILY: `${prefix}.family`,
  CARDS: `${prefix}.cards`,
  PROMOTIONS: `${prefix}.promotions`,
  PAYMENT_METHODS: `${prefix}.paymentMethods`,
}

export default (Bus) => {
  Bus.add(F.FAMILY, filterFamily)
  Bus.add(F.CARDS, filterCards)
}

const filterCards = (cards) => {
  const family = _.get(addiesaas, '$data.profile.user.members', [])
  assignCardToFamilyMember(cards, family)
}

const filterFamily = (family) => {
  const cards = _.get(addiesaas, '$data.profile.user.cards.playcard', [])
  if (!_.isEmpty(cards)) {
    assignCardToFamilyMember(cards, family)
  } else {
    initMembers()
  }
}

const initMembers = (family) => {
  _.forOwn(family, member => {
    if (!_.has(member.$$data, 'card')) {
      member.$$data.card = null
    }
    if (!_.has(member.$$data, 'cardNumber')) {
      member.$$data.cardNumber = null
    }
    if (!_.has(member.$$data, 'cardObject')) {
      member.$$data.cardObject = {}
    }
  })
}

const assignCardToFamilyMember =  (cards, family) => {
  const formatters = addiesaas.$fn.formatters
  if (!_.isEmpty(family) && !_.isEmpty(cards)) {
    _.forOwn(cards, card => {
      const cardMember = _.get(card, 'family_member.data')
      if (cardMember) {
        _.forOwn(family, member => {
          const memberId = member.$$data.id
          if (cardMember.id === memberId) {
            if (!member.$$data.card) {
              member.$$data.card = []
            }
            if (!member.$$data.cardObject) {
              member.$$data.cardObject = []
            }

            let cardNumber = member.$$data.cardNumber || ''
            const number = formatters.maskLeft(card.number, 'XXXXXX0000', {clip: true})
            cardNumber += ((cardNumber ? '<br/>' : '')  + number)
            member.$$data.cardNumber = cardNumber

            member.$$data.cardObject.push(card)
            member.$$data.card.push(card.id)
          }
        })
      }
    })
  }
}

